import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import { sName, sProducts, sTimestamp } from "../Strings";

export default function Selector({ onSelect }) {
  const [value, setValue] = React.useState(20); // default select 2nd Value
  const productCollection = collection(db, sProducts);
  const productRef2 = query(productCollection, orderBy(sName));
  const productRef1 = query(productCollection, orderBy(sTimestamp, "desc"));

  const handleChange = (event) => {
    setValue(event.target.value);

    if (event.target.value === 10) getNewData(productRef2);
    else getNewData(productRef1);
  };

  function getNewData(ref) {
    getDocs(ref).then((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      onSelect(data);
    });
  }

  //   useEffect(() => {}, []);

  return (
    <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
      <InputLabel>Filter</InputLabel>
      <Select
        value={value}
        sx={{ fontSize: 14 }}
        label="Filter"
        onChange={handleChange}
      >
        <MenuItem value={10} sx={{ fontSize: 14 }}>
          Name
        </MenuItem>
        <MenuItem value={20} sx={{ fontSize: 14 }}>
          Date Added
        </MenuItem>
      </Select>
    </FormControl>
  );
}
